import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import {
  BackendError,
  ConcurrencyError,
  NetworkError,
  UnknownError,
} from '@vectronic/oof/shared/util';
import { catchError, Observable, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        const status = err.status;

        if (status === 0) {
          return throwError(() => new NetworkError());
        }
        if (status === 412) {
          return throwError(
            () =>
              new ConcurrencyError(
                'The resource was modified by another user. Please reload first.',
              ),
          );
        }
        if (status >= 500) {
          return throwError(
            () => new BackendError(status, 'Server error. Please try again later.'),
          );
        }

        return throwError(() => new BackendError(status, err.error?.message || err.message));
      }
      return throwError(() => new UnknownError());
    }),
  );
};
